import { Exit, Player } from "../objects";
import levelGoalKit from "./levelGoalKit";

class Level12 extends levelGoalKit {
  constructor() {
    super();
    this.name = "Time trial";
    this.diamondsGoal = 7;
  }

  get id() {
    return this.constructor.key
  }

  onInteractWith(el) {
    super.onInteractWith(el)
    
    if (el.isClass(Exit)) {
      this.onComplete();
    }
  }

  onAddElement(el) {
    if (el.isClass(Player)) {
      el.power = 1;
      el.hasPickaxe = true;
    }

  }

}

Level12.key = 'level_12'
export default Level12;
